import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { WebStorage } from '../../../auth/storage/web.storage';
import {
    ITEMS_PER_PAGE,
    PAGE_SIZE,
} from 'src/app/demo/constants/pagination.constants';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Common } from 'src/app/demo/utils/common';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { forkJoin, Observable } from 'rxjs';
import * as moment from 'moment';
import { Dropdown } from 'primeng/dropdown';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';

@Component({
    selector: 'app-mark-transfer',
    templateUrl: './mark-transfer.component.html',
    styleUrls: ['./mark-transfer.component.scss'],
})
export class MarkTransferComponent {
    userData: any;
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 100,
        totalItems: 0,
        sort: 'staffName,asc',
    };
    roomList: RoomDTO[] = [];
    filteredRoomList: RoomDTO[] = [];
    roomObj: RoomDTO = {};
    designationList: MasterLookupDTO[] = [];
    selectedRoomId: any;
    selectedDesignation: any;
    selectedStatus: any;
    staffList: any[] = [];
    selectAllStaff: boolean = false;
    selectedStaff: any[] = [];
    selectedStudentIds: number[] = [];
    selectedStaffList: any[] = [];
    actualStaffList: StaffDTO[] = [];
    staffSearchInput: any;
    submitForm: boolean = false;
    items!: MenuItem[];
    activeIndex: number = 0;
    profileBgColor: string[] = [];
    selectedDate: any = Common.momentTimeZoneDate(new Date());
    staffObj: StaffDTO = {};
    staffSignIn!: FormGroup;
    isClickedOnce: boolean = false;
    currentAttendanceOf!: any;
    staffAttendance!: AttendanceDTO;
    selectedStaffRooms: RoomDTO[] = [];
    fromOverView: boolean = false;
    selectedStaffsFromOverview: any[] = [];
    isSaving: boolean = false;
    constructor(
        private lookupService: LookupService,
        private operationService: OperationService,
        private storage: WebStorage,
        private formBuilder: FormBuilder,
        private messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private confirmationService: ConfirmationService,
        private sanitizer: DomSanitizer,
    ) {
        this.roomObj = this.config.data;
        this.profileBgColor = profielBackgroundColor;
        this.activeIndex = this.config.data.activeIndex;
        this.fromOverView = this.config.data.fromOverView;
        this.selectedStaffsFromOverview = this.fromOverView
            ? this.config.data.selectedStaffs
            : [];
    }

    ngOnInit(): void {
        this.userData = this.storage.getUserData();
        const currentTime24hr = Common.momentTimeZoneTime(new Date());
        const currentDate = Common.momentTimeZoneDate(new Date());

        this.items = [
            {
                label: 'Select Staff',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        summary: 'First Step',
                        key: 'message',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
            {
                label: 'Confirm Staff',
                command: (event: any) =>
                    this.messageService.add({
                        severity: 'info',
                        key: 'message',
                        summary: 'Second Step',
                        detail: event.item.label,
                        life: 3000,
                    }),
            },
        ];
        this.staffSignIn = this.formBuilder.group({
            id: [''],
            signInTime: [''],
            signOutTime: [currentTime24hr],
            attendedTime: [''],
            signInBy: [''],
            signOutBy: [''],
            note: [''],
            hasSignIn: [false],
            date: [currentDate],
            roomId: ['', [Validators.required]],
            staffName: [''],
            status: 'A',
            schoolId: [''],
            hasStudentId: [''],
        });
        this.queryData();
        this.getRoomData();
        this.getDesignationData();

        this.lookupService
            .getStaffById(this.userData.refTableId)
            .subscribe((res: HttpResponse<StaffDTO>) => {
                let temp: StaffDTO = {};
                this.staffObj = res.body ? res.body : temp;
                this.queryData();
            });
    }

    onActiveIndexChange(event: number) {
        this.activeIndex = event;
    }

    complete() {
        if (this.selectedStudentIds.length != 0) {
            this.activeIndex = 1;
            this.filterRoomListForTransfer();
        } else {
            this.activeIndex = 0;
        }
        this.getRoomData();
    }

    filterRoomListForTransfer() {
        const staffRoomIds = new Set<number>();
        this.selectedStaff.forEach((staff) => {

            if (staff.roomId) {
                staffRoomIds.add(staff.roomId);
            }
        });

        // Filter out rooms that selected staff are currently in
        this.filteredRoomList = this.roomList.filter((room) => {
            if (!room.id) return true;
            return !staffRoomIds.has(room.id);
        });
    }

    prevPage() {
        this.activeIndex = 0;
    }

    private formatTo12Hour(time: string): string {
        if (!time) return ''; // Handle undefined or null cases
        const [hours, minutes] = time.split(':'); // Extract hours and minutes
        let hour = parseInt(hours, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12; // Convert 0/24 to 12
        return `${hour.toString().padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
    }

    onSave() {
        if (this.isSaving) {
            return;
        }
        this.isSaving = true;

        if (!Array.isArray(this.selectedStaff)) return;

        const formatTo12Hour = (time: string): string => {
            if (!time) return ''; // Handle undefined or null cases
            const [hours, minutes] = time.split(':'); // Extract hours and minutes
            let hour = parseInt(hours, 10);
            const ampm = hour >= 12 ? 'PM' : 'AM';
            hour = hour % 12 || 12; // Convert 0/24 to 12
            return `${hour.toString().padStart(2, '0')}:${minutes}:00 ${ampm}`; // Add seconds as 00
        };

        const invalidStaff: string[] = [];

        this.selectedStaff.forEach(
            (student: { staffName: any; id: any; signInTime: any }) => {
                if (
                    this.isSignOutBeforeSignIn(
                        student.signInTime,
                        formatTo12Hour(this.staffSignIn.value.signOutTime),
                    )
                ) {
                    invalidStaff.push(student.staffName);
                }
            },
        );

        if (invalidStaff.length > 0) {
            alert(
                `${invalidStaff.join(', ')}'s Sign-Out Time cannot be same or before Sign-In Time.`,
            );
            this.isSaving = false;
            return;
        }

        // Prepare payload for unified transfer API
        const oldAttendanceIds = this.selectedStaff.map((staff) => staff.id);
        const transferPayload = {
            oldAttendanceIds: oldAttendanceIds,
            hasStudentId: false,
            staffId: this.userData.refTableId,
            newRoomId: this.staffSignIn.value.roomId,
            transferBy: this.userData.firstName,
            transferTime: formatTo12Hour(this.staffSignIn.value.signOutTime),
            schoolId: this.userData.schoolId,
            date: Common.convertLocalDateToUTC(this.staffSignIn.value.date),
        };

        this.operationService.transferAttendance(transferPayload).subscribe({
            next: () => this.handleSuccess('Staff Transferred successfully.'),
            error: (error) => {
                this.handleError(
                    error.error.title || 'Failed to transfer staff',
                );
                this.isSaving = false;
            },
        });
    }
    isSignOutBeforeSignIn(
        signInTime: string | undefined,
        signOutTime: string | undefined,
    ): boolean {
        const format = 'hh:mm:ss A'; // 12-hour format with AM/PM
        const signInMoment = moment(signInTime, format);
        const signOutMoment = moment(signOutTime, format);
        return signOutMoment.isSameOrBefore(signInMoment); // Checks if Sign-Out is same or before Sign-In
    }

    private handleSuccess(detail: string) {
        this.selectedStaffList = [];
        this.submitForm = false;
        const message = {
            severity: 'success',
            life: 3000,
            summary: 'Success',
            detail,
        };
        setTimeout(() => {
            this.ref.close(message);
            this.isSaving = false;
        }, 200);
    }

    private handleError(detail: string, summary: string = 'Error') {
        this.messageService.add({
            severity: 'error',
            life: 3000,
            summary,
            detail,
        });
    }

    queryData() {
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = this.pageContext.sort;
        this.search['roomId.equals'] = this.selectedRoomId ?? undefined;

        const { startUtc, endUtc } = Common.getUtcDayRange(this.selectedDate);
        this.search['date.greaterThanOrEqual'] = startUtc;
        this.search['date.lessThanOrEqual'] = endUtc;

        this.search['staffId.equals'] = !Common.isAdminUserLogin(this.storage)
            ? this.userData.refTableId
            : undefined;
        // this.search['staffName.contains'] = this.staffSearchID;
        this.search['hasSignIn.equals'] = true;
        this.search['staffId.specified'] = true;
        this.search['designationName.equals'] = this.selectedDesignation;
        this.search['staffName.contains'] = this.staffSearchInput;

        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryAttendance(this.search)
            .subscribe(async (data: HttpResponse<AttendanceDTO[]>) => {
                let temp: AttendanceDTO[] = [];
                this.staffList = data.body != undefined ? data.body : temp;
                for (const staff of this.staffList) {
                    if (staff) {
                        if (this.fromOverView == true) {
                            this.selectedStaff = this.staffList.filter(
                                (staff) =>
                                    this.selectedStaffsFromOverview.some(
                                        (s) => s.id === staff.staffId,
                                    ),
                            );
                        } else {
                            this.selectedStaffList.forEach(
                                (res: AttendanceDTO) => {
                                    if (res.staffId == staff.staffId) {
                                        staff.selected = res.selected == true;
                                    }
                                },
                            );
                        }
                    }

                    this.getStaffDetails(staff);
                }
                this.pageContext.totalItems = Number(
                    data.headers.get('X-Total-Count'),
                );

                this.staffList.forEach((element: AttendanceDTO) => {
                    this.getProfileDocument(element);
                });

                // If opened from overview/parent with activeIndex=1, filter rooms after data is loaded
                if (this.fromOverView && this.activeIndex === 1) {
                    this.filterRoomListForTransfer();
                }
            });
    }
    getProfileDocument(element: AttendanceDTO) {
        if (element.staffPhotoUuid) {
            this.lookupService
                .queryDocumentByPhotoUid(element.staffPhotoUuid)
                .subscribe((response: HttpResponse<Blob>) => {
                    const body = response?.body;
                    if (body) {
                        const url = this.createImgFromBuffer(body);
                        element.profileimg = url;
                    }
                });
        } else {
            element.profileimg = undefined;
        }
    }

    getStaffDetails(staff: AttendanceDTO) {
        const staffId = staff?.staffId;
        this.lookupService
            .queryStaff({
                'id.equals': staffId,
                size: PAGE_SIZE,
                'schoolId.equals': this.userData.schoolId,
                'designation.notEquals': 'Kiosk',
            })
            .subscribe(
                (res: HttpResponse<StaffDTO[]>) => {
                    const temp: StaffDTO[] = [];
                    const response: StaffDTO[] = res.body ? res.body : temp;
                    staff.staffs =
                        response && response.length > 0 ? response[0] : {};
                },
                (error: HttpErrorResponse) => {
                    console.error(
                        `Error: ${error.error.title} for staffId: ${staffId}`,
                    );
                },
            );
    }

    getRoomData() {
        this.search = {};
        this.search['sort'] = 'name,asc';
        this.search['status.equals'] = 'A';
        this.search['id.notEquals'] = this.roomObj.id;
        this.search.size = 10;
        this.search['schoolId.equals'] = this.userData.schoolId;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
            });
    }

    getDesignationData() {
        this.lookupService
            .queryMasterLookups({
                'schoolId.equals': this.userData.schoolId,
                'type.equals': 'Designation',
                'name.notEquals': 'Kiosk',
                'status.equals': 'A',
            })
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.designationList = res.body ? res.body : temp;
            });
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }

    onClear() {
        this.staffSearchInput = undefined;
        this.selectedRoomId = undefined;
        this.selectedDesignation = undefined;
        this.selectedStaff = [];
        this.actualStaffList = [];
        this.selectedStudentIds = [];
        this.selectAllStaff = false;
        this.queryData();
    }

    onRemoveStaff(event: Event, staff: any) {
        this.confirmationService.confirm({
            key: 'confirm2',
            target: event.target as EventTarget,
            message: `Do you want to Remove ${staff.staffName}?`,
            acceptButtonStyleClass: 'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-secondary p-button-outlined',
            defaultFocus: 'none',
            accept: () => this.deleteStaff(staff),
            reject: () => {},
        });
    }

    deleteStaff(stud: any) {
        try {
            if (!stud || !stud.staffId) {
                throw new Error('Invalid staff data');
            }

            if (
                !this.selectedStaffList ||
                !this.selectedStudentIds ||
                !this.selectedStaff ||
                !this.staffList
            ) {
                throw new Error('Required arrays are not initialized');
            }

            this.selectedStaffList = this.selectedStaffList.filter(
                (item) => item.staffId !== stud.staffId,
            );

            this.selectedStudentIds = this.selectedStudentIds.filter(
                (staffId) => staffId !== stud.staffId,
            );

            this.selectedStaff = this.selectedStaff.filter(
                (item) => item.staffId !== stud.staffId,
            );

            const mainListStaff = this.staffList.find(
                (item) => item.staffId === stud.staffId,
            );
            if (mainListStaff) {
                mainListStaff.selected = false;
            }

            this.selectAllStaff = false;
            this.submitForm = false;

            // Show success message
            this.messageService.add({
                key: 'message',
                severity: 'success',
                life: 3000,
                summary: 'Success',
                detail: 'Staff Removed Successfully',
            });
        } catch (error) {
            console.error('Error in deleteStaff:', error);
            this.messageService.add({
                key: 'message',
                severity: 'error',
                life: 3000,
                summary: 'Error',
                detail: (error as Error).message || 'Failed to remove staff',
            });
        }
    }

    toggleSelection(staff: any) {
        const index = this.selectedStaff.findIndex(
            (selected) => selected.id === staff.id,
        );
        if (index !== -1) {
            this.selectedStaff.splice(index, 1);
        } else {
            this.selectedStaff.push(staff);
        }
        this.selectedStudentIds = this.selectedStaff.map(
            (selected) => selected.staffId,
        );

        // this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
        //   this.selectedStudentIds.includes(item.id as number)
        // );
        this.selectedStaffList = this.selectedStaff;
    }

    isSelected(staff: StaffDTO): boolean {
        return this.selectedStaff.includes(staff);
    }

    toggleAllSelection() {
        this.staffList.forEach(
            (staff) => (staff.selected = this.selectAllStaff),
        );

        if (this.selectAllStaff) {
            this.selectedStaff = [...this.staffList];
        } else {
            this.selectedStaff = [];
        }
        this.selectedStudentIds = this.selectedStaff.map(
            (selected) => selected.staffId,
        );

        // this.selectedStaffList = this.actualStaffList.filter((item: StaffDTO) =>
        //   this.selectedStudentIds.includes(item.id as number)
        // );
        this.selectedStaffList = this.selectedStaff;
    }

    checkboxChanged() {
        if (this.staffList && this.staffList?.length !== 0) {
            if (this.isAllSelected()) this.selectAllStaff = true;
            else this.selectAllStaff = false;
        } else {
            this.selectAllStaff = false;
        }
    }

    isAllSelected(): boolean {
        return this.staffList.every((staff) => staff.selected);
    }

    private patchDateValue(dateValue: any): string {
        let formattedDate;
        // Check if the value is a valid date before formatting
        if (dateValue && !isNaN(new Date(dateValue).getTime())) {
            formattedDate = Common.convertLocalDateToUTC(dateValue);
        } else {
            // If the value is not a valid date, set it to null or handle it accordingly
            formattedDate = '';
        }
        return formattedDate;
    }

    getBackgroundColor(roomId: any): string {
        if (!roomId) return this.profileBgColor[0];
        const index = (roomId - 1) % this.profileBgColor.length;
        return this.profileBgColor[index];
    }

    getInitials(name?: string): string {
        if (!name?.trim()) return '';
        const words = name.trim().split(/[-\s]+/); // Split by hyphens or spaces
        const firstLetter = words[0][0]?.toUpperCase(); // Get the first letter of the first word
        const secondLetter = words[1]?.[0]?.toUpperCase() || ''; // Get the first letter of the second word (if it exists)
        return `${firstLetter}${secondLetter}`.trim(); // Concatenate and trim
    }

    filterRoom(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['status.equals'] = 'A';
        this.search['name.contains'] = filter;
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
                this.filterRoomListForTransfer();
            });
        this.search = {};
    }
}
